import { Button, HStack } from '@chakra-ui/react'
import { WhatsAppNumber } from '@missionlabs/types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface NumberActionsProps {
    number?: Partial<WhatsAppNumber>
}

const NumberActions: React.FC<NumberActionsProps> = ({ number }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    if (!number) return null

    return (
        <HStack align="end">
            {number.provisioningStatus !== 'NUMBER_REGISTRATION_SUCCESS' && (
                <Button
                    variant="primary"
                    onClick={() => navigate(`/admin/whatsapp/${number.numberID}/verify`)}
                >
                    {t('admin.whatsapp.verify.button')}
                </Button>
            )}
            <Button
                variant="negatory"
                onClick={() => navigate(`/admin/whatsapp/${number.numberID}/delete`)}
            >
                {t('admin.whatsapp.deleteNumber')}
            </Button>
        </HStack>
    )
}

export default NumberActions
